module.exports = __webpack_public_path__ + "static/media/miami-10.cec4802c.jpg";